const Alphabet = [
  'A',
  'Ä',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'Ö',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'Ü',
  'V',
  'W',
  'Y',
  'Z',
];

export default Alphabet;
